export interface ITextEditorSelection {
  startLineNumber: number;
  startColumn: number;
  endLineNumber?: number;
  endColumn?: number;
}

export enum IPreemptive {
  capable = 'capable',
  incapable = 'incapable',
  indifferent = 'indifferent',
}

export enum IPublished {
  soap = 'soap',
  web = 'web',
  sql = 'sql',
  rest = 'rest',
}

export enum IPublishedRestScope {
  table = 'table',
  catalog = 'catalog',
  currentRecord = 'currentRecord',
  currentSelection = 'currentSelection',
}

export interface IPublishedRestOptions {
  table: string;
  scope: IPublishedRestScope;
}

export interface IOriginalMethodAttributes {
  invisible: boolean;
  shared: boolean;
  executedOnServer: boolean;
  preemptive: IPreemptive;
  publishedSoap: boolean;
  publishedWsdl: boolean;
  publishedWeb: boolean;
  publishedSql: boolean;
  published4DMobile: IPublishedRestOptions;
}

export interface IMethodAttributes
  extends Omit<IOriginalMethodAttributes, 'published4DMobile'> {
  publishedRest: boolean;
  publishedRestOptions: IPublishedRestOptions;
}

export const PublishOptions: { [key: string]: IPublished } = {
  publishedSoap: IPublished.soap,
  publishedWeb: IPublished.web,
  publishedSql: IPublished.sql,
  publishedRest: IPublished.rest,
};

type BuiltinTheme = 'vs' | 'vs-dark' | 'hc-black' | 'hc-light';

type IColors = {
  [colorId: string]: string;
};

interface ITokenThemeRule {
  token: string;
  foreground?: string;
  background?: string;
  fontStyle?: string;
}

interface IStandaloneThemeData {
  base: BuiltinTheme;
  inherit: boolean;
  rules: ITokenThemeRule[];
  encodedTokensColors?: string[];
  colors: IColors;
}

export type IMonacoThemeResponse = IStandaloneThemeData | null;
